// material-ui
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

// ==============================|| Lightweight Loader ||============================== //
// Replaces the old full-screen Lottie "car" animation (an 80KB JSON + lottie-react) that
// covered the whole screen on every navigation / table load / detail fetch. That felt
// heavy, blocking and irritating — even a 200ms request flashed a big animated overlay.
//
// This is a small, inline MUI spinner: non-blocking, instant, and it keeps the same
// `Loader` API so every existing `<Loader message="..." />` call site keeps working.

export default function Loader({ message, sx }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        py: 6,
        width: '100%',
        ...sx
      }}
    >
      <CircularProgress size={32} thickness={4} />
      {message ? (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      ) : null}
    </Box>
  );
}

// Slim top progress bar — non-blocking, for route/page transitions or inline use.
export function TopLinearLoader() {
  return (
    <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: (theme) => theme.zIndex.drawer + 2001 }}>
      <LinearProgress />
    </Box>
  );
}
